var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1953_32779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.79547 17.8316C2.6909 17.8316 1.79547 16.9362 1.79547 15.8316V15.3547C1.79547 14.6871 1.90343 14.1162 2.11934 13.6419C2.33524 13.1676 2.61365 12.8074 2.95456 12.5615C3.71593 12.0345 4.44604 11.6392 5.14491 11.3757C5.84377 11.1122 6.54548 10.9805 7.25002 10.9805C7.95457 10.9805 8.65344 11.1166 9.34662 11.3889C10.0398 11.6612 10.7671 12.0521 11.5284 12.5615C11.8807 12.8074 12.1648 13.1676 12.3807 13.6419C12.5966 14.1162 12.7046 14.6871 12.7046 15.3547V15.8316C12.7046 16.9362 11.8091 17.8316 10.7046 17.8316H3.79547Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.25004,
    cy: 5.55931,
    r: 2.72728,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79547 17.8316C8.6909 17.8316 7.79547 16.9362 7.79547 15.8316V15.3547C7.79547 14.6871 7.90343 14.1162 8.11934 13.6419C8.33524 13.1676 8.61365 12.8074 8.95456 12.5615C9.71593 12.0345 10.446 11.6392 11.1449 11.3757C11.8438 11.1122 12.5455 10.9805 13.25 10.9805C13.9546 10.9805 14.6534 11.1166 15.3466 11.3889C16.0398 11.6612 16.7671 12.0521 17.5284 12.5615C17.8807 12.8074 18.1648 13.1676 18.3807 13.6419C18.5966 14.1162 18.7046 14.6871 18.7046 15.3547V15.8316C18.7046 16.9362 17.8091 17.8316 16.7046 17.8316H9.79547Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.25,
    cy: 5.55931,
    rx: 2.72728,
    ry: 2.72728,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1953_32779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    transform: "translate(0 0.332031)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.a49869ac632628179d4e63e2f35e4e5b.svg";
export { ForwardRef as ReactComponent };